import React, { useRef, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y, EffectFade } from 'swiper/modules';
import 'swiper/swiper-bundle.css';
import { Link } from 'react-router-dom';
import styles from './slider.module.css';
import './sliderSwiperPagination.css';

// !!! This component need to install "swiper"
function Slider() {
    const swiperRef = useRef(null);

    useEffect(() => {
        if (swiperRef.current) {
            // Access Swiper instance and disable touch/swipe interactions
            swiperRef.current.swiper.allowTouchMove = false;
        }
    }, []);

    return (
        <div className={styles.sliderContainer}>
            <div className={styles.downArrow}>
                <img src="Images/down-arrow.png" alt="Down Arrow" />
            </div>
            <Swiper // Slide's property 
                ref={swiperRef}
                modules={[Navigation, Pagination, A11y, EffectFade]}
                spaceBetween={0}
                slidesPerView={1}
                effect="fade"
                speed={1150}
                loop={true}
                navigation={{
                    prevEl: `.${styles.swiperButtonPrev}`,
                    nextEl: `.${styles.swiperButtonNext}`
                }}
                pagination={{clickable: true}}
            >
               <SwiperSlide>
                    <div className={styles.slideContent}>
                        <img src="Images/schoolBuilding1.jpg" alt="School Building 1" />
                        <div className={styles.schoolName}>
                            <h1>โรงเรียนเทศบาลตำบลพยัคฆภูมิพิสัย</h1>
                            <h2>PHAYAKKHAPHUM PHISAI SUB DISTRICT MUNICIPALITY SCHOOL</h2>
                            <Link className={styles.linkButton} to='/information/history'>ประวัติความเป็นมา</Link>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className={styles.slideContent}>
                        <img src="Images/schoolBuilding2.jpg" alt="School Building 2" />
                        <div className={styles.schoolName}>
                            <h1>โรงเรียนเทศบาลตำบลพยัคฆภูมิพิสัย</h1>
                            <h2>PHAYAKKHAPHUM PHISAI SUB DISTRICT MUNICIPALITY SCHOOL</h2>
                            <Link className={styles.linkButton} to='/information/administrator'>ผู้บริหาร</Link>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className={styles.slideContent}>
                        <img src="Images/schoolBuilding3.jpg" alt="School Building 3" />
                        <div className={styles.schoolName}>
                            <h1>โรงเรียนเทศบาลตำบลพยัคฆภูมิพิสัย</h1>
                            <h2>PHAYAKKHAPHUM PHISAI SUB DISTRICT MUNICIPALITY SCHOOL</h2>
                            <Link className={styles.linkButton} to='/contact'>ติดต่อเรา</Link>
                        </div>
                    </div>
                </SwiperSlide>
            </Swiper>
            <div className={styles.swiperNavButton}>
                <div className={`${styles.swiperButtonPrev} swiper-button-prev`}></div>
                <div className={`${styles.swiperButtonNext} swiper-button-next`}></div>
            </div>
        </div>
    );
}

export default Slider;
